import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  type ButtonProps,
  Stack,
  Typography,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded';
import {useTranslation} from 'react-i18next';
import DialogTitleWithClose from '../DialogTitle';

export enum IconType {
  WARNING = 'WARNING',
  START = 'START',
}

interface IConfirmationDialogueProps {
  open: boolean;
  title: string;
  handleConfirm: () => void;
  handleClose: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  content?: JSX.Element;
  isLoading?: boolean;
  icon?: IconType;
  slotProps?: {
    confirmButton?: ButtonProps;
    cancelButton?: ButtonProps;
  };
}

export function ConfirmationDialog({
  open,
  title,
  handleConfirm,
  handleClose,
  confirmLabel,
  cancelLabel,
  content,
  isLoading,
  icon,
  slotProps,
}: IConfirmationDialogueProps) {
  const {t} = useTranslation('common');
  const defaultContent = <DialogContentText>{t('actionIsPermanent')}</DialogContentText>;

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitleWithClose onClose={handleClose}>{title}</DialogTitleWithClose>
      <DialogContent>
        <Stack direction="row" spacing={2}>
          {icon === IconType.WARNING && <WarningIcon color="warning" style={{fontSize: 46}} />}
          {icon === IconType.START && <PlayCircleRoundedIcon style={{fontSize: 46}} />}
          <Typography>{content ?? defaultContent}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} disabled={isLoading} {...slotProps?.cancelButton}>
          {cancelLabel ?? t('cancel')}
        </Button>

        <Button
          onClick={() => {
            handleConfirm();
          }}
          color="primary"
          variant="contained"
          size="small"
          loading={isLoading}
          {...slotProps?.confirmButton}
        >
          {confirmLabel ?? t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
